/**
 * Sysadmin Catalog → Prompts route wrapper (PR-E refactor 2026-05-12).
 *
 * Thin wrapper that mounts the shared <PromptEditor scope="sysadmin" />.
 * All prompts authoring logic lives in
 * `@/components/prompt-editor-shared/PromptEditor.tsx` — this file's
 * job is just the TanStack file-route binding so the framework picks
 * up the route at /sysadmin/catalog/prompts.
 */
import { createFileRoute } from '@tanstack/react-router';
import { PromptEditor } from '@/components/prompt-editor-shared/PromptEditor';

export const Route = createFileRoute('/sysadmin/catalog/prompts')({
  component: SysadminPromptsPage,
});

function SysadminPromptsPage() {
  return <PromptEditor scope="sysadmin" />;
}
